import { ScrollToBottomIfLarge } from "source/app/services/UI/UI";

export function PrepareTextAreaForInput(textAreaElement: string) {
    ScrollToBottomIfLarge("clickTarget_nodeName");

    const element: any = document.getElementById(textAreaElement)!;
    element.focus();
    element.setSelectionRange(element.value.length, element.value.length);
}
